/**
 * @desc 类型选框
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamCheckBoxResponse>>> {
  return defHttp.get({
    url: '/web/EPManage/getType',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.ParamCheckBoxResponse>>> {
  return defHttp.get({
    url: '/mock/web/EPManage/getType',
  });
}
